import request from '@/utils/request'

// 获取投放组列表
export function getReleaseGroupList(params = {}) {
  return request({
    url: '/short_report/short_release_group',
    method: 'get',
    params
  })
}

// 添加投放组
export function addReleaseGroup(data = {}) {
  return request({
    url: '/short_report/short_release_group',
    method: 'post',
    data
  })
}

// 投放组组长列表
export function launchTeamLeader(params = {}) {
  return request({
    url: `/short_report/release_group_leader`,
    method: 'get',
    params
  })
}

// 修改投放组
export function updateReleaseGroup(data = {}) {
  return request({
    url: `/short_report/short_release_group/${data.id}`,
    method: 'PUT',
    data
  })
}
// 删除投放组
export function deleteMy(id) {
  return request({
    url: `/short_report/short_release_group/${id}`,
    method: 'delete'
  })
}

// 获取投放组投手列表
export function getListOfPitchersInTheLaunchGroup(params = {}) {
  return request({
    url: `/short_report/release_group_user`,
    method: 'get',
    params
  })
}

// 添加投放组投手
export function addOfPitchersInTheLaunchGroup(data = {}) {
  return request({
    url: `/short_report/release_group_user_add`,
    method: 'post',
    data
  })
}

// 删除投放组投手
export function deleteOfPitchersInTheLaunchGroup(data = {}) {
  return request({
    url: `/short_report/release_group_user_del`,
    method: 'DELETE',
    data
  })
}

// 获取运营组列表
export function getOperationGroupList(params = {}) {
  return request({
    url: `/short_report/short_operation_group`,
    method: 'GET',
    params
  })
}

// 添加运营组
export function addOperationGroup(data = {}) {
  return request({
    url: `/short_report/short_operation_group`,
    method: 'post',
    data
  })
}

// 修改运营组
export function modifyOperationGroup(data = {}) {
  return request({
    url: `/short_report/short_operation_group/${data.id}`,
    method: 'PUT',
    data
  })
}

// 删除运营组
export function deleteOperationGroup(id) {
  return request({
    url: `/short_report/short_operation_group/${id}`,
    method: 'delete'
  })
}

// 获取运营者列表
export function getOperatorList(params = {}) {
  return request({
    url: `/short_report/operation_group_user`,
    method: 'get',
    params
  })
}

// 添加运营者
export function addOperator(data = {}) {
  return request({
    url: `/short_report/operation_group_user_add`,
    method: 'post',
    data
  })
}

// 删除运营者
export function deleteOperator(data = {}) {
  return request({
    url: `/short_report/operation_group_user_del`,
    method: 'DELETE',
    data
  })
}

// 获取短剧列表
export function getShortPlayList(params) {
  return request({
    url: '/short_report/short_novels',
    method: 'get',
    params
  })
}

// 添加短剧
export function addShortPlay(data = {}) {
  return request({
    url: `/short_report/short_novels`,
    method: 'post',
    data
  })
}

// 修改短剧
export function modifyShortPlay(data = {}) {
  return request({
    url: `/short_report/short_novels/${data.id}`,
    method: 'PUT',
    data
  })
}

// 删除短剧
export function deleteShortPlay(id) {
  return request({
    url: `/short_report/short_novels/${id}`,
    method: 'delete'
  })
}
// 投放位置列表
export function dropLocationList(params = {}) {
  return request({
    url: `/short_report/short_positions`,
    method: 'get',
    params
  })
}

// 添加投放位置
export function addDropLocationList(data = {}) {
  return request({
    url: `/short_report/short_positions`,
    method: 'post',
    data
  })
}

// 修改投放位置
export function modifyDropLocationList(data = {}) {
  return request({
    url: `/short_report/short_positions/${data.id}`,
    method: 'put',
    data
  })
}

// 获取绑定关系列表
export function getBindingRelationList(params = {}) {
  return request({
    url: `/short_report/short_promotions`,
    method: 'get',
    params
  })
}
// 添加投放关系
export function addReleaseRelationship(data = {}) {
  return request({
    url: `/short_report/short_promotions`,
    method: 'post',
    data
  })
}
// 修改投放关系
export function modifyReleaseRelationship(id, data = {}) {
  return request({
    url: `/short_report/short_promotions/${id}`,
    method: 'put',
    data
  })
}

// 删除投放关系
export function deleteReleaseRelationship(id) {
  return request({
    url: `/short_report/short_promotions/${id}`,
    method: 'DELETE'
  })
}

// 获取广告主
export function getAdvertiser(params = {}) {
  return request({
    url: `/short_report/advertiser_list`,
    method: 'get',
    params
  })
}

// 获取公众号列表
export function getTheListOfOfficialAccount(params = {}) {
  return request({
    url: `/short_report/wechat_list`,
    method: 'get',
    params
  })
}

// 获取报表列表
export function getReportList(params = {}) {
  return request({
    url: `/short_report/short_promotion_report`,
    method: 'get',
    params
  })
}

// 导出报表
export function exportReport(data = {}) {
  return request({
    url: `/short_report/export_short_data`,
    method: 'post',
    data
  })
}
// 广告主消耗导出报表
export function exportAdq(data = {}) {
  return request({
    url: `/short_report/export_short_data_advertiser`,
    method: 'post',
    data
  })
}
// 修改消耗
export function modifyConsumption(data = {}) {
  return request({
    url: `/short_report/edit_consume`,
    method: 'PUT',
    data
  })
}

// 获取总计报表列表
export function getTotalReportList(params = {}) {
  return request({
    url: `/short_report/short_promotion_total_report`,
    method: 'get',
    params
  })
}

// 导出总计报表
export function exportTotalReport(data = {}) {
  return request({
    url: `/short_report/export_short_total_data`,
    method: 'POST',
    data
  })
}

// 获取平台
export function getPlatform(params = {}) {
  return request({
    url: `/common/specific_platform_list`,
    method: 'get',
    params
  })
}

// T图列表
export function tFigureList(params = {}) {
  return request({
    url: `/short_report/short_promotion_t_report`,
    method: 'get',
    params
  })
}

// 导出T图列表
export function exportTFigureList(data = {}) {
  return request({
    url: `/short_report/export_short_t_data`,
    method: 'post',
    data
  })
}

// 手动触发T+图报表
export function toUpdate(params = {}) {
  return request({
    url: `short_report/short_t_report_update`,
    method: 'get',
    params
  })
}

// 分组导出
export function bindwechatreportnew(params = {}) {
  return request({
    url: `/short_report/short_report_new`,
    method: 'get',
    params
  })
}
// 导出T图列表
export function exportTFigureListmonry(data = {}) {
  return request({
    url: `/account_management/export_funds`,
    method: 'post',
    data
  })
}
